import React, { useEffect } from 'react';
import './GrowSubscriptionComplete.css';
import moneytreeLogo from '../../assets/icons/moneytree-logo.svg';

const APPS_FLYER_REDIRECT_PATH = 'https://moneytree.onelink.me/Crav/mt-web-for-grow';

const localization = {
  en: {
    heading: 'Upgrade complete!',
    message: 'Your paid plan features are now unlocked. Would you like to return to the app?',
    buttonText: 'Return to the App'
  },
  ja: {
    heading: '登録がが完了しました！',
    message: '有料プランの機能をご利用いただけます。アプリに戻りますか？',
    buttonText: 'アプリに戻る'
  }
};

export default function GrowSubscriptionComplete({ locale }) {
  useEffect(() => {
    // The global min-width (1024px) is set by mt-web-modules for the main app layout.
    // Temporarily remove this restriction for the upgrade complete page, restoring it when unmounting.
    const originalMinWidth = document.body.style.minWidth;
    document.body.style.minWidth = 'auto';

    return () => {
      document.body.style.minWidth = originalMinWidth;
    }
  }, []);

  const returnToApp = () => {
    window.location.href = APPS_FLYER_REDIRECT_PATH;
  };

  const { heading, message, buttonText } = localization[locale] || localization.ja;

  return (
    <div className="upgrade-complete-container">
      <div className="mt-header">
        <img src={moneytreeLogo} alt="Moneytree logo" className="logo-moneytree-img" />
      </div>
      <div className="upgrade-complete-content-container">
        <div className="upgrade-complete-content">
          <h1 className="upgrade-complete-heading">{heading}</h1>
          <p className="upgrade-complete-message">
            {message}
          </p>
          <button
            className="upgrade-complete-button"
            onClick={returnToApp}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}
